import {
  AdminApiV1QuestionAttemptsGetResponse200,
  AdminQuestionAttempt,
  Questionnaire,
} from '@letrustech/letrus-api-interfaces/dist/interfaces/letrus_api';
import {AxiosResponse} from 'axios';
import letrusAPI from 'APIs/letrusAPI/axiosInstance';
import {QuestionAnswer} from 'utils/types/questionnaires';

export const fetchQuestionnaireByIdService = (
  questionnaireId: number,
): Promise<AxiosResponse<Questionnaire>> =>
  letrusAPI(`/api/v1/questionnaires/${questionnaireId}/`);

export const postQuestionAnswerService = (
  data: Partial<QuestionAnswer>,
  params?: Record<string, number>,
): Promise<AxiosResponse<AdminQuestionAttempt>> =>
  letrusAPI(`/api/v1/question_attempts/`, {
    method: 'post',
    params,
    data,
  });

export const postPracticeTestAnswerService = (
  data: Partial<QuestionAnswer>,
  params?: Record<string, number>,
): Promise<AxiosResponse<AdminQuestionAttempt>> =>
  letrusAPI(`/api/v1/question_attempts/practice_test/`, {
    method: 'post',
    params,
    data,
  });

export const fetchQuestionnaireAnswersByStepService = (
  stepId: number | string,
  learningPathUserInstanceId?: number | string,
): Promise<AxiosResponse<AdminApiV1QuestionAttemptsGetResponse200>> =>
  letrusAPI(`/api/v1/question_attempts/`, {
    params: {
      step: stepId,
      learning_path_user_instance: learningPathUserInstanceId,
    },
  });

export const fetchQuestionAnswersByStudentService = (
  studentId: number,
): Promise<AxiosResponse<AdminApiV1QuestionAttemptsGetResponse200>> =>
  letrusAPI(`/api/v1/question_attempts/`, {
    params: {
      user: studentId,
    },
  });

export const fetchPracticeTestAnswersByStepService = (
  stepId: number | string,
  learningPathUserInstanceId?: number | string,
): Promise<AxiosResponse<AdminApiV1QuestionAttemptsGetResponse200>> =>
  letrusAPI(`/api/v1/question_attempts/practice_test/`, {
    params: {
      step: stepId,
      learning_path_user_instance: learningPathUserInstanceId,
      limit: 40,
    },
  });

export const fetchPracticeTestFeedbackService = (
  stepId: number | string,
  learningPathUserInstanceId?: number | string,
): Promise<AxiosResponse<AdminApiV1QuestionAttemptsGetResponse200>> =>
  letrusAPI(`/api/v1/question_attempts/practice_test_feedback/`, {
    params: {
      step: stepId,
      learning_path_user_instance: learningPathUserInstanceId,
    },
  });
